// src/utils/statusColor.js

export const getStatusColor = (status) => {
  const map = {
    New: "#2196f3", // blue
    "No Response": "#ff9800", // orange
    Irrelevant: "#9e9e9e", // grey
    "Introduction Call": "#3f51b5", // indigo
    "Proposal Sent": "#9c27b0", // purple
    "Closed Won": "#4caf50", // green
    "Closed Lost": "#f44336", // red
  };
  return map[status] || "#bdbdbd"; // default grey if not found
};

export const STATUS_OPTIONS = [
  "New",
  "No Response",
  "Irrelevant",
  "Introduction Call",
  "Proposal Sent",
  "Closed Won",
  "Closed Lost",
];
